import CheckIcon from 'components/icons/Check';
import styled from 'styled-components';
import { from } from 'styles/mixins';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background-color: ${({ theme }) => theme.colors.primary};
  background-image: radial-gradient(
    ellipse 200% 160% at 50% 100%,
    rgba(41, 127, 213, 0.8) 0%,
    rgba(21, 102, 180, 0.5) 40%,
    rgba(10, 87, 160, 0.25) 65%,
    rgba(0, 74, 143, 0) 100%
  );
  color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  padding: 1.5rem;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: normal;
`;

export const Benefits = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;

  ${from.tablet`
    grid-template-columns: 1fr 1fr;
  `}
`;

export const Benefit = styled.li`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  line-height: 1.3;
`;

export const Check = styled(CheckIcon)`
  flex-shrink: 0;
  width: 0.875rem;
  height: 0.875rem;
  color: ${({ theme }) => theme.colors.basicGold};
`;

export const Footer = styled.div`
  display: flex;
`;
